import { req, endpoints } from './index'

export default class backend {


  static pregister = {

    register(email:string, nickname:string, ref?:string) {
      return req(`${endpoints.pregister}?email=${email}&nickname=${nickname}&ref=${ref}`).then((res) => {return res})
    }

  }

}
